// extracted by mini-css-extract-plugin
export var button = "_gm-2";
export var card = "_gm-0";
export var closeButtonContainer = "_gm-3";
export var iconContainer = "_gm-1";